// @flow

import SearchComponent from './search';
import SearchContainer from './search.container';

export {
  SearchComponent,
};

export default SearchContainer;
